import { ROLES } from "@/common/permissions";
import { ReactNode } from "react";
import { RoleProtectedRoute } from "./RoleProtectedRoute";

export function ViewerProtectedRoute({
  children,
}: {
  children: ReactNode;
}) {
  return <RoleProtectedRoute role={ROLES.WAITER}>{children}</RoleProtectedRoute>;
} 